module.exports = __webpack_public_path__ + "img/1F1F9-1F1FC.1af7d02a.svg";